module.exports = __webpack_public_path__ + "static/img/detail_beatles_02.370eb0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/the-beatles-rock-band-website/detail_beatles_02.jpg
// module id = 283
// module chunks = 2